(function () {

  function getMultiple(wrapper) {
    return parseInt(wrapper.dataset.sellingMultiple, 10) || 1;
  }

  function getAvailable(wrapper) {
    var v = parseInt(wrapper.dataset.maxQty, 10);
    return (!isNaN(v)) ? v : 999999;
  }

  function getStart(multiple, available) {
    if (available <= 0) { return multiple; } // OOS — show pack size
    return (available < multiple) ? available : multiple;
  }

  function packValue(n, multiple, available) {
    var start = getStart(multiple, available);
    if (available <= 0) { return multiple; } // OOS
    n = parseInt(n, 10);
    if (isNaN(n) || n < 1) { return start; }
    if (available < multiple) { return available; }
    if (n < multiple) { return multiple; }
    if (n >= available) { return available; }
    var snapped = Math.round(n / multiple) * multiple;
    return Math.max(multiple, snapped > available ? available : snapped);
  }

  function patchInput(input, MULTIPLE, AVAILABLE) {
    if (input._smCartPatched) { return; }
    input._smCartPatched = true;

    var OUT_OF_STOCK = (AVAILABLE <= 0);
    var START = getStart(MULTIPLE, AVAILABLE);

    var proto = Object.getPrototypeOf(input);
    var descriptor = Object.getOwnPropertyDescriptor(proto, 'value');
    if (descriptor) {
      Object.defineProperty(input, 'value', {
        get: function () { return descriptor.get.call(this); },
        set: function (v) {
          var n = parseInt(v, 10);
          if (!isNaN(n) && n > 0 && n < START) {
            descriptor.set.call(this, String(START));
          } else if (!OUT_OF_STOCK && !isNaN(n) && n > AVAILABLE) {
            descriptor.set.call(this, String(AVAILABLE));
          } else {
            descriptor.set.call(this, v);
          }
        }
      });
    }

    input.setAttribute('min', START);
    input.setAttribute('max', OUT_OF_STOCK ? MULTIPLE : AVAILABLE);
    input.setAttribute('step', (!OUT_OF_STOCK && AVAILABLE < MULTIPLE) ? 1 : MULTIPLE);
    input.value = packValue(input.value, MULTIPLE, AVAILABLE);

    input.addEventListener('change', function () {
      this.value = packValue(this.value, MULTIPLE, AVAILABLE);
    });
    input.addEventListener('blur', function () {
      this.value = packValue(this.value, MULTIPLE, AVAILABLE);
    });
  }

  function applyAll() {
    document.querySelectorAll('.js-qty__wrapper[data-selling-multiple]').forEach(function (wrapper) {
      var MULTIPLE  = getMultiple(wrapper);
      if (MULTIPLE < 2) { return; }
      var AVAILABLE = getAvailable(wrapper);
      var input = wrapper.querySelector('.js-qty__num');
      if (input) { patchInput(input, MULTIPLE, AVAILABLE); }
    });
  }

  // Single delegated listener — survives Impulse re-rendering buttons
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.js-qty__adjust');
    if (!btn) { return; }
    var wrapper = btn.closest('.js-qty__wrapper');
    if (!wrapper || !wrapper.dataset.sellingMultiple) { return; }
    var MULTIPLE      = getMultiple(wrapper);
    if (MULTIPLE < 2) { return; }
    var AVAILABLE     = getAvailable(wrapper);
    var OUT_OF_STOCK  = (AVAILABLE <= 0);
    var START         = getStart(MULTIPLE, AVAILABLE);
    var input         = wrapper.querySelector('.js-qty__num');
    if (!input) { return; }

    e.preventDefault();
    e.stopImmediatePropagation();

    if (OUT_OF_STOCK || AVAILABLE < MULTIPLE) {
      var proto0 = Object.getPrototypeOf(input);
      var desc0  = Object.getOwnPropertyDescriptor(proto0, 'value');
      if (desc0) { desc0.set.call(input, String(START)); } else { input.value = START; }
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    var current = parseInt(input.value, 10) || START;
    var isPlus  = btn.classList.contains('js-qty__adjust--plus');
    var next;

    if (isPlus) {
      var nextMultiple = Math.floor(current / MULTIPLE) * MULTIPLE + MULTIPLE;
      next = (nextMultiple > AVAILABLE) ? AVAILABLE : nextMultiple;
    } else {
      next = (current === AVAILABLE && AVAILABLE % MULTIPLE !== 0)
        ? Math.floor(AVAILABLE / MULTIPLE) * MULTIPLE
        : current - MULTIPLE;
    }

    next = Math.max(START, next);

    var proto = Object.getPrototypeOf(input);
    var descriptor = Object.getOwnPropertyDescriptor(proto, 'value');
    if (descriptor) {
      descriptor.set.call(input, String(next));
    } else {
      input.value = next;
    }

    input.dispatchEvent(new Event('change', { bubbles: true }));

  }, true);

  // Snap on form submit
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form) { return; }
    form.querySelectorAll('.js-qty__wrapper[data-selling-multiple]').forEach(function (wrapper) {
      var MULTIPLE  = getMultiple(wrapper);
      if (MULTIPLE < 2) { return; }
      var AVAILABLE = getAvailable(wrapper);
      var input = wrapper.querySelector('.js-qty__num');
      if (input) { input.value = packValue(input.value, MULTIPLE, AVAILABLE); }
    });
  }, true);

  // Re-patch after DOM changes
  if (window.MutationObserver) {
    new MutationObserver(function (mutations) {
      if (mutations.some(function (m) { return m.addedNodes.length > 0; })) { applyAll(); }
    }).observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('cart:updated', applyAll);
  document.addEventListener('shopify:section:load', applyAll);
  window.addEventListener('load', applyAll);

})();

